import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { make } from 'vuex-pathify'

const state = {
  all: [],
  single: null,
  owners: [],
  products: [],
  vendors: [],
  product: null,
  productId: null,
  vendorId: null,
  milestonesMeta: null,
  milestones: {},
  newSubscriptionPeriod: null,
  taskApplicability: null,
  metaDataFields: null,
  financialPeriods: []
}
export default {
  namespaced: true,
  state,
  actions: {
    ...make.actions(state),
    ...actions
  },
  getters: {
    ...make.getters(state),
    ...getters
  },
  mutations: {
    ...make.mutations(state),
    ...mutations
  }
}
